import { ScholarshipManagementDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadScholarshipManagement = createAction(
  '[ScholarshipManagement] Load ScholarshipManagement'
);

export const loadScholarshipManagementSuccess = createAction(
  '[ScholarshipManagement] Load ScholarshipManagement Success',
  props<{ scholarshipManagement: ScholarshipManagementDto[] }>()
);

export const loadScholarshipManagementFailure = createAction(
  '[ScholarshipManagement] Load ScholarshipManagement Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addScholarshipManagement = createAction(
  '[ScholarshipManagement] Add ScholarshipManagement',
  props<{ newScholarshipManagement: ScholarshipManagementDto }>()
);

export const addScholarshipManagementSuccess = createAction(
  '[ScholarshipManagement] Add ScholarshipManagement Success',
  props<{ newScholarshipManagement: ScholarshipManagementDto }>()
);

export const addScholarshipManagementFailure = createAction(
  '[ScholarshipManagement] Add ScholarshipManagement Failure',
  props<{ error: any }>()
);

/**
 * Upload Scholarship-record to Collection Actions
 */
export const uploadExcelStudentRecord = createAction(
  '[ScholarshipManagement] Upload Excel ScholarshipManagement',
  props<{ uploadExcelRecord: ScholarshipManagementDto[] }>()
);

export const uploadExcelStudentRecordSuccess = createAction(
  '[Student-record] Upload Excel ScholarshipManagement Success',
  props<{ uploadExcelRecord: ScholarshipManagementDto[] }>()
);

export const uploadExcelStudentRecordFailure = createAction(
  '[Student-record] Upload Excel ScholarshipManagement Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchScholarshipManagementRecord = createAction(
  '[ScholarshipManagement] Search  ScholarshipManagement Record',
  props<{ query: string }>()
);

/**
 * Update ScholarshipManagement Collection Actions
 */
export const updateScholarshipManagement = createAction(
  '[ScholarshipManagement] Update ScholarshipManagement',
  props<{ updateScholarshipManagement: ScholarshipManagementDto }>()
);

export const updateScholarshipManagementSuccess = createAction(
  '[ScholarshipManagement] Update ScholarshipManagement Success',
  props<{ updateScholarshipManagement: ScholarshipManagementDto }>()
);

export const updateScholarshipManagementFailure = createAction(
  '[ScholarshipManagement] Update ScholarshipManagement Failure',
  props<{ error: any }>()
);

/**
 * Remove ScholarshipManagement Collection Actions
 */
export const removeScholarshipManagement = createAction(
  '[ScholarshipManagement] Remove ScholarshipManagement',
  props<{ ids: string }>()
);

export const removeScholarshipManagementSuccess = createAction(
  '[ScholarshipManagement] Remove ScholarshipManagement Success',
  props<{ ids: string }>()
);

export const removeScholarshipManagementFailure = createAction(
  '[ScholarshipManagement] Remove ScholarshipManagement Failure',
  props<{ error: any }>()
);
